
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_1lx2n_3",
  "child": "awsui_child_18582_1lx2n_7",
  "horizontal": "awsui_horizontal_18582_1lx2n_18",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1lx2n_22",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_1lx2n_26",
  "horizontal-xs": "awsui_horizontal-xs_18582_1lx2n_30",
  "horizontal-s": "awsui_horizontal-s_18582_1lx2n_34",
  "horizontal-m": "awsui_horizontal-m_18582_1lx2n_38",
  "horizontal-l": "awsui_horizontal-l_18582_1lx2n_42",
  "horizontal-xl": "awsui_horizontal-xl_18582_1lx2n_46",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_1lx2n_50",
  "child-horizontal-xxxs": "awsui_child-horizontal-xxxs_18582_1lx2n_55",
  "child-horizontal-xxs": "awsui_child-horizontal-xxs_18582_1lx2n_61",
  "child-horizontal-xs": "awsui_child-horizontal-xs_18582_1lx2n_67",
  "child-horizontal-s": "awsui_child-horizontal-s_18582_1lx2n_73",
  "child-horizontal-m": "awsui_child-horizontal-m_18582_1lx2n_79",
  "child-horizontal-l": "awsui_child-horizontal-l_18582_1lx2n_85",
  "child-horizontal-xl": "awsui_child-horizontal-xl_18582_1lx2n_91",
  "child-horizontal-xxl": "awsui_child-horizontal-xxl_18582_1lx2n_97",
  "vertical": "awsui_vertical_18582_1lx2n_106",
  "child-vertical-xxxs": "awsui_child-vertical-xxxs_18582_1lx2n_110",
  "child-vertical-xxs": "awsui_child-vertical-xxs_18582_1lx2n_114",
  "child-vertical-xs": "awsui_child-vertical-xs_18582_1lx2n_118",
  "child-vertical-s": "awsui_child-vertical-s_18582_1lx2n_122",
  "child-vertical-m": "awsui_child-vertical-m_18582_1lx2n_126",
  "child-vertical-l": "awsui_child-vertical-l_18582_1lx2n_130",
  "child-vertical-xl": "awsui_child-vertical-xl_18582_1lx2n_134",
  "child-vertical-xxl": "awsui_child-vertical-xxl_18582_1lx2n_138"
};
  